import React from "react";
import {Link} from "react-router-dom";
import {Box, Button} from "@mui/material";
import {BadgeOutlined, DashboardOutlined, MyLocationOutlined} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import UserManagementLayout from "../user/user-management-layout";

export default function CourierManagementLayout({activeTab = "dashboard", children, ...props}) {
    const {t} = useTranslation();
    const navigation = <Box component="nav" aria-label={t("CourierManagement")}
        sx={{display: "flex", flexWrap: "wrap", gap: 0.5, p: 0.5, my: 0.5, borderRadius: 2, bgcolor: "action.hover"}}>
        {[
            {value: "dashboard", path: "/distributor/users/couriers", label: "CourierDashboardTab", icon: <DashboardOutlined/>},
            {value: "tracking", path: "/distributor/users/couriers/tracking", label: "CourierLiveTracking", icon: <MyLocationOutlined/>},
            {value: "profiles", path: "/distributor/users/couriers/profiles", label: "CourierProfiles", icon: <BadgeOutlined/>},
        ].map(({value, path, label, icon}) => <Button key={value} component={Link} to={path} size="small"
            startIcon={icon} aria-current={activeTab === value ? "page" : undefined}
            sx={{px: 1.5, py: 0.75, borderRadius: 1.5, textTransform: "none", whiteSpace: "nowrap",
                color: activeTab === value ? "primary.main" : "text.secondary",
                bgcolor: activeTab === value ? "background.paper" : "transparent",
                boxShadow: activeTab === value ? 1 : 0,
                "&:hover": {bgcolor: activeTab === value ? "background.paper" : "action.hover"}}}>{t(label)}</Button>)}
    </Box>;
    return <UserManagementLayout {...props} activeTab="couriers" navigationAction={navigation}>
        {children}
    </UserManagementLayout>;
}
